export enum ROLE {
  UNCONFIRMED_USER,
  CONFIRMED_USER,
  SUPPORT,
  CONTENT_MANAGER,
  GAME_MASTER,
  ADMIN,
}
